import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addTerminalSuccess,
  addTerminalFailure,
  //
  deleteTerminalSuccess,
  deleteTerminalFailure,
  //
  editTerminalSuccess,
  editTerminalFailure,
  //
  fetchTerminals as fetchTerminalAction,
  fetchTerminalsSuccess,
  fetchTerminalsFailure,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
} from "./actions";
import {
  ADD_TERMINAL,
  DELETE_TERMINAL,
  EDIT_TERMINAL,
  FETCH_TERMINALS,
  GET_VIEW_DATA,
} from "./constants";

export function* fetchTerminalsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.data ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(api(token).get, `/api/terminal?${query}`);
    yield put(fetchTerminalsSuccess(data));
  } catch (e) {
    yield put(fetchTerminalsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching terminal list!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/terminal/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching terminal data!"));
  }
}

export function* addTerminalSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/terminal/add`, payload);
    if (data) {
      yield put(successAlert("Terminal created successfully!"));
      yield put(addTerminalSuccess());
    }
  } catch (e) {
    yield put(addTerminalFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editTerminalSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/terminal/edit/${payload.id}`,
      payload
    );
    if (data) {
      yield put(successAlert("Terminal updated successfully!"));
      yield put(editTerminalSuccess());
      yield put(getViewDataAction(payload.id));
    }
  } catch (e) {
    yield put(editTerminalFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteTerminalSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/terminal/${payload}`);
    if (data) {
      yield put(successAlert("Terminal deleted successfully!"));
      yield put(deleteTerminalSuccess());
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteTerminalFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchTerminalsFlow() {
  yield takeEvery(FETCH_TERMINALS, fetchTerminalsSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addTerminalFlow() {
  yield takeEvery(ADD_TERMINAL, addTerminalSaga);
}
export function* editTerminalFlow() {
  yield takeEvery(EDIT_TERMINAL, editTerminalSaga);
}
export function* deleteTerminalFlow() {
  yield takeEvery(DELETE_TERMINAL, deleteTerminalSaga);
}

export default function* TerminalSaga() {
  yield all([
    fetchTerminalsFlow(),
    addTerminalFlow(),
    editTerminalFlow(),
    deleteTerminalFlow(),
    getViewDataFlow(),
  ]);
}
